import { Component, Input, OnChanges, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { userSelectors } from '../../../../core/ngrx/selectors';
import { State } from '@core/ngrx/reducers';
import { Store } from '@ngrx/store';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from '@app/shared/pipes/truncate/truncate.pipe';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SplitPricePipe } from '@app/shared/pipes/split-price/split-price.pipe';

@Component({
    selector: 'app-program-card',
    templateUrl: './program-details-card.component.html',
    styleUrls: ['./program-details-card.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, TruncatePipe, ImgPipe, FontAwesomeModule, SplitPricePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramDetailsCardComponent implements OnChanges {
    types = [];
    priceDropPrice: any;

    hidePrices$ = this.store.select(userSelectors.hideProgramPrices);

    icons: any = {
        arrow: faChevronRight,
        pin: faMapMarkerAlt,
    };

    @Input() program: any = {};

    constructor(private store: Store<State>) {}

    ngOnChanges(): void {
        if (this.program && this.program.type) {
            this.types = this.program.type.split(',');
        }
        this.priceDropPrice = this.program?.priceDropPrice;
    }
}
